import styled from '@emotion/styled';
import CircularProgress from '@mui/material/CircularProgress';

import { PaletteColor } from '../../styling/AppStyles';

/**
 * A MUI <CircularProgres> with custom styles
 */
const ExinMuiCircularProgress = styled(CircularProgress)`
  color: ${PaletteColor.text};
`;

export default ExinMuiCircularProgress;
